import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './styles/header.css';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useCart } from '../CartContext/CartContext';

const Header = () => {
  const { getCartItemCount } = useCart();
  const [isScrolled, setIsScrolled] = useState(false);
  const [omItems, setOmItems] = useState([]);
  const [terapiItems, setTerapiItems] = useState([]);
  const [uddannelseItems, setUddannelseItems] = useState([]);
  const [hoveredMenu, setHoveredMenu] = useState(null);

  // Håndter scroll event for at ændre header udseende
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fetch menu data
  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        // Hent psykologer til "Om os" undermenuen
        const omDocRef = doc(db, 'content', 'om');
        const omDoc = await getDoc(omDocRef);
        
        if (omDoc.exists() && omDoc.data().psykologer) {
          setOmItems(omDoc.data().psykologer.map(p => ({
            id: p.id,
            title: p.navn,
            link: `/om/${p.id}`
          })));
        }
        
        // Hent terapiområder til "Terapi" undermenuen
        const terapiOmraderDocRef = doc(db, 'content', 'terapiOmrader');
        const terapiOmraderDoc = await getDoc(terapiOmraderDocRef);
        
        if (terapiOmraderDoc.exists() && terapiOmraderDoc.data().omrader) {
          setTerapiItems(terapiOmraderDoc.data().omrader.map(o => ({
            id: o.id,
            title: o.title,
            link: `/terapi/${o.id}`
          })));
        }
        
        // Hent uddannelser til "Uddannelse" undermenuen
        const uddannelserDocRef = doc(db, 'content', 'uddannelser');
        const uddannelserDoc = await getDoc(uddannelserDocRef);
        
        if (uddannelserDoc.exists() && uddannelserDoc.data().uddannelser) {
          setUddannelseItems(uddannelserDoc.data().uddannelser.map(u => ({
            id: u.id,
            title: u.title,
            link: `/uddannelse/${u.id}`
          })));
        }
      } catch (error) {
        console.error('Fejl ved hentning af menu-data:', error);
      }
    };

    fetchMenuItems();
  }, []);

  const handleMenuHover = (menuName) => {
    setHoveredMenu(menuName);
  };

  const handleMenuLeave = () => {
    setHoveredMenu(null);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <Link to="/">
            <img src="/media/logo/psykologiskperspektiv-logo.avif" alt="Psykologisk Perspektiv" className="logo-image" />
          </Link>
        </div>

        <nav className="nav-menu">
          <ul className="main-menu">
            <li><Link to="/">Forside</Link></li>
            
            <li 
              className={`menu-item-dropdown ${hoveredMenu === 'om' ? 'active' : ''}`}
              onMouseEnter={() => handleMenuHover('om')}
              onMouseLeave={handleMenuLeave}
            >
              <Link to="/om" aria-expanded={hoveredMenu === 'om'}>
                Om os
                <span className="dropdown-arrow">▼</span>
              </Link>
              <ul className="dropdown-menu">
                {omItems.map(item => (
                  <li key={item.id}>
                    <Link to={item.link}>
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            
            <li 
              className={`menu-item-dropdown ${hoveredMenu === 'terapi' ? 'active' : ''}`}
              onMouseEnter={() => handleMenuHover('terapi')}
              onMouseLeave={handleMenuLeave}
            >
              <Link to="/terapi" aria-expanded={hoveredMenu === 'terapi'}>
                Terapi
                <span className="dropdown-arrow">▼</span>
              </Link>
              <ul className="dropdown-menu">
                {terapiItems.map(item => (
                  <li key={item.id}>
                    <Link to={item.link}>
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            
            <li><Link to="/supervision">Supervision</Link></li>
            
            <li 
              className={`menu-item-dropdown ${hoveredMenu === 'uddannelse' ? 'active' : ''}`}
              onMouseEnter={() => handleMenuHover('uddannelse')}
              onMouseLeave={handleMenuLeave}
            >
              <Link to="/uddannelse" aria-expanded={hoveredMenu === 'uddannelse'}>
                Uddannelse
                <span className="dropdown-arrow">▼</span>
              </Link>
              <ul className="dropdown-menu">
                {uddannelseItems.map(item => (
                  <li key={item.id}>
                    <Link to={item.link}>
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
            
            <li><Link to="/praktisk-priser">Praktisk & Priser</Link></li>
            <li><Link to="/shop">Shop</Link></li>
            <li><Link to="/viden">Viden</Link></li>
            <li><Link to="/kontakt">Kontakt</Link></li>
            <li className="cart-menu-item">
              <Link to="/kurv" className="cart-link">
                Kurv {getCartItemCount() > 0 && <span className="cart-count">({getCartItemCount()})</span>}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
